// src/i18n.js
import { createI18n } from 'vue-i18n'
import ru from './locales/ru.json'
import en from './locales/en.json'
import uz from './locales/uz.json'

const saved = localStorage.getItem('lang') || 'ru'

const i18n = createI18n({
  legacy: false,
  locale: saved,        // default: ru
  fallbackLocale: 'ru',
  messages: { ru, en, uz }
})

export default i18n
